var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled from 'styled-components';
import { Elevation } from '../../../../theme/elevation';
import useThemeBreakpoints from '../../../../hooks/useThemeBreakpoints';
import MenuList from './MenuList/MenuList';
import Icon, { IconName } from '../../../Icon';
import OptionWithCheckbox from './OptionWithCheckbox';
import OptionWithInfo from './OptionWithInfo';
import MultiValueContainer from './MultiValueContainer';
import VirtualizedMenuList from './MenuList/VirtualizedMenuList';
import { Group, GroupHeading } from './Group';
import SubMenusMenuList from './MenuList/SubMenusMenuList';
import CustomOption from './CustomOption';
var DropdownIndicator = function () { return (_jsx(IconWrapper, { children: _jsx(Icon, { name: IconName.CHEVRON_DOWN }, void 0) }, void 0)); };
var IndicatorSeparator = function () { return null; };
// @TODO remove SubMenu logic when redesign is done
export var getCustomComponents = function (_a) {
    var isMulti = _a.isMulti, isVirtualized = _a.isVirtualized, isGroup = _a.isGroup, isOptionWithInfo = _a.isOptionWithInfo, subMenus = _a.subMenus, customOptionContent = _a.customOptionContent, themeFamily = _a.themeFamily;
    var isMultiComponents = { Option: OptionWithCheckbox, ValueContainer: MultiValueContainer };
    var groupComponents = { Group: Group, GroupHeading: GroupHeading };
    var optionWithInfoComponents = { Option: OptionWithInfo };
    var OptionComponent = customOptionContent
        ? { Option: CustomOption(customOptionContent) }
        : null;
    var VirtualizedMenuListMemoized = useMemo(function () { return VirtualizedMenuList(themeFamily); }, [themeFamily]);
    var MenuListMemoized = useMemo(function () { return MenuList(themeFamily); }, [themeFamily]);
    return {
        components: __assign(__assign(__assign(__assign({ IndicatorSeparator: IndicatorSeparator, MenuList: subMenus
                ? SubMenusMenuList
                : isVirtualized
                    ? VirtualizedMenuListMemoized
                    : MenuListMemoized, DropdownIndicator: DropdownIndicator }, (isMulti && __assign({}, isMultiComponents))), (isGroup && __assign({}, groupComponents))), (isOptionWithInfo && __assign({}, optionWithInfoComponents))), (customOptionContent && __assign({}, OptionComponent))),
    };
};
export var getCustomStyles = function (theme, themeFamily, subMenus, menuPortalTarget, fieldBoxRef) { return ({
    container: function (provided) { return (__assign(__assign({}, provided), { width: '100%', position: 'static' })); },
    control: function (provided) { return (__assign(__assign({}, provided), { textTransform: 'capitalize', border: 0, outline: 'none', boxShadow: 'none', minHeight: 0, backgroundColor: 'none', cursor: 'pointer' })); },
    valueContainer: function (provided) { return (__assign(__assign({}, provided), { padding: 0, fontSize: '14px', whiteSpace: 'nowrap', flexWrap: 'unset' })); },
    menuPortal: function (provided) { return (__assign(__assign({}, provided), { zIndex: 7 })); },
    menu: function (provided) {
        // If the dropdown is used inside a modal, we portal it to document.body in order to prevent modal inner scroll
        // In this case default menu width is not calculated right because of fieldBox paddings
        // So we take correct 'width' from fieldBox that wraps dropdown
        // And calculate 'left' param by ourselves according to fieldBox paddings
        var _a = useThemeBreakpoints({ component: 'fieldBox' }), paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight;
        var width = menuPortalTarget ? fieldBoxRef.current.offsetWidth : '100%';
        var left = menuPortalTarget ? "calc((" + paddingLeft + " + " + paddingRight + ") / -2)" : 0;
        return __assign(__assign({}, provided), { width: width,
            left: left, marginTop: 2, border: 0, borderRadius: '8px', boxShadow: theme.elevation[Elevation.DEPTH2], zIndex: 2 });
    },
    menuList: function (provided) {
        var dark = theme.families.search[themeFamily].dark;
        var height = useThemeBreakpoints({ component: 'dropdownMenu' }).height;
        return __assign(__assign({}, provided), { maxHeight: height, padding: '0 12px', backgroundColor: dark });
    },
    option: function (provided, state) {
        var _a = theme.families.search[themeFamily], main = _a.main, light = _a.light, text = _a.text, disabled = _a.disabled, selectedText = _a.selectedText;
        var height = useThemeBreakpoints({ component: 'dropdownOption' }).height;
        var getDisabledStyle = function (state) {
            return (state.isDisabled && {
                color: disabled,
                cursor: 'default',
            });
        };
        return __assign(__assign(__assign({}, provided), { display: 'flex', alignCenter: 'center', minWidth: '100%', width: 'fit-content', minHeight: height, margin: '9px 0', fontSize: '14px', borderRadius: '5px', textTransform: 'capitalize', color: state.isSelected ? selectedText : text, cursor: 'pointer', backgroundColor: state.isSelected ? main : state.isFocused ? light : null, '&:hover': {
                backgroundColor: !state.isSelected && light,
                color: selectedText,
            }, ':active': {
                backgroundColor: main,
            }, '&:last-child': {
                borderBottom: 'none',
            } }), getDisabledStyle(state));
    },
    groupHeading: function (provided) { return (__assign(__assign({}, provided), { fontSize: '14px' })); },
}); };
var IconWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var templateObject_1;
